import { CompanyConfiguration, User } from '@gloat/types';

interface IsHireAppAvailableOptions {
  companyConfig?: Partial<CompanyConfiguration>;
  isStaffModeOn?: boolean;
  user?: User;
  isNewNavigation: boolean;
}

export const useIsHireAppAvailableForUsers = ({
  companyConfig,
  isStaffModeOn = false,
  user,
  isNewNavigation,
}: IsHireAppAvailableOptions): boolean => {
  if (isStaffModeOn) {
    return true;
  }

  const canViewPositions = user?.imob?.access?.hirePositions?.canView;
  const canViewProjects = user?.imob?.access?.hireProjects?.canView;
  const canViewSuccession = user?.imob?.access?.hireSuccession?.canView;
  const isStudioOn = companyConfig?.Studio?.isOn && user?.imob?.access?.canAccessStudioEditor && isNewNavigation;

  return Boolean(canViewPositions || canViewProjects || canViewSuccession || isStudioOn);
};
